// components/card-mask/card-mask.ts
import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-card-mask',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './card-mask.html',
  styleUrls: ['./card-mask.scss']
})
export class CardMask {
  @Input() hasMask: boolean = false;
}
